export default {
      id: "ic_croix-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_croix-usage",
      toString: function () {
        return this.url;
      }
    }